var _circle, _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#F38D33"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 12.5,
    x2: 11.5,
    y2: 12.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44488 10.8073L10.8167 8.32667C11.0614 8.07029 11.0614 7.65771 10.8151 7.40217C10.5689 7.14749 10.1718 7.14834 9.9272 7.40387L8.62833 8.76218V3.65369C8.62833 3.29289 8.34704 3 7.99969 3C7.65317 3 7.37269 3.29289 7.37269 3.65369L7.37269 8.76218L6.07301 7.40387C5.8284 7.14834 5.43132 7.14749 5.18509 7.40217C5.06197 7.53037 5 7.69761 5 7.8657C5 8.03209 5.06197 8.19933 5.18346 8.32667L7.55533 10.8073C7.67355 10.9304 7.83336 11 7.99969 11C8.16684 11 8.32665 10.9304 8.44488 10.8073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file-download.291733cea8690849233fb4901a0dc002.svg";
export { ForwardRef as ReactComponent };